import * as React from 'react';

import { useTheme } from '@mui/material';
import ProductSearchTable from 'components/ProductSearchTable';
import ProducerPreference from 'containers/ProducerPreference';
import ResetPasswordContainer from 'containers/ResetPassword';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import AdminToolsHeader from './AdminToolsHeader';
import useStyles from './useStyles';
import AdminToolItem from '../../components/AdminToolItem';
import MaterialButton from '../../components/MaterialButton';
import { ADMIN_EDIT_USER_ROLE } from '../../constants/routePaths';
import { PagePaper } from '../../styles/themeComponents';
import AddClient from '../AddClient';
import AddUserToWorkspace from '../AddUserToWorkspace';
import ChangePassword from '../ChangePassword';
import ConditionViewerRoleContainer from '../ConditionViewerRole';
import CreateWorkspace from '../CreateWorkspace';
import ProductMove from '../ProductMove';
import RemoveUserFromWorkspace from '../RemoveUserFromWorkspace';
import UserCreate from '../UserCreate';
import UserWorkspaceList from '../UserWorkspaceList';
import ViewCategoriesAndProducts from '../ViewCategoriesAndProducts';

const AdminToolsContainer: React.FC = () => {
  const { t } = useTranslation();

  const styles = useStyles(useTheme());

  return (
    <PagePaper>
      <AdminToolsHeader />
      <br />

      <ConditionViewerRoleContainer
        render={(viewerRoles) => !viewerRoles.viewerRoleIsAdmin ? (
          <>
            <Link to={{ pathname: ADMIN_EDIT_USER_ROLE }}>
              <MaterialButton variant="outlined" soft teal>
                {t('users.editUserRole')}
              </MaterialButton>
            </Link>
            <br /><br />
          </>
        ) : null}
      />

      <br />
      <br />

      <AdminToolItem title={t('users.createUser')} component={<UserCreate />} />
      <AdminToolItem title={'Send User Password Reset Email'} component={<ResetPasswordContainer />} />
      <ConditionViewerRoleContainer
        render={(viewerRoles) => !viewerRoles.viewerRoleIsAdmin ? (
          <AdminToolItem title={t('users.changePassword')} component={<ChangePassword />} />
        ) : null}
      />
      <AdminToolItem
        title={t('admin.addUserWorkspace')}
        component={<AddUserToWorkspace />}
      />
      <AdminToolItem title={t('admin.removeUserWorkspace')} component={<RemoveUserFromWorkspace />} />
      <AdminToolItem
        title={t('admin.createWorkspace')}
        component={<CreateWorkspace />}
      />
      <AdminToolItem title={t('admin.userWorkspaces')} component={<UserWorkspaceList />} />
      <ConditionViewerRoleContainer
        render={(viewerRoles) => !viewerRoles.viewerRoleIsAdmin ? (
          <AdminToolItem title={t('admin.producerPreference')} component={<ProducerPreference />} />
        ) : null}
      />
      <AdminToolItem
        title={t('admin.createClient')}
        component={<AddClient />}
      />
      <AdminToolItem title={t('admin.moveProductWorkspace')} component={<ProductMove />} />
      <AdminToolItem
        title="Categories"
        component={<ViewCategoriesAndProducts />}
      />
      <AdminToolItem
        title={t('admin.searchProduct')}
        component={<ProductSearchTable />}
      />
    </PagePaper>
  );
};

export default AdminToolsContainer;